import { render, staticRenderFns } from "./InsCmsCat1.vue?vue&type=template&id=50172a59&scoped=true&"
import script from "./InsCmsCat1.vue?vue&type=script&lang=ts&"
export * from "./InsCmsCat1.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsCat1.vue?vue&type=style&index=0&id=50172a59&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50172a59",
  null
  
)

export default component.exports